import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'

const CircleCheckIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d={PATH}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

CircleCheckIcon.propTypes = {
  className: PropTypes.string
}

CircleCheckIcon.defaultProps = {
  className: 'tw:h-4 tw:w-4'
}

export default CircleCheckIcon
